import clsx from 'clsx';
import React, {
  ReactNode,
} from 'react';

type DefaultRenderOptionRowProps = {
  label?: string;
};

function DefaultRenderOptionRow({ label }: DefaultRenderOptionRowProps) {
  return (
    <div className="flex flex-col items-start justify-start w-full text-left gap-2">
      <div className="flex flex-row items-center justify-start w-full gap-1 ">
        <span className="font-semibold">
          {typeof label === 'string' ? label : '--'}
        </span>
      </div>
    </div>
  );
}

export type LookupOptionProps = {
  props: Record<string, any>;
  children?: ReactNode;
  id?: string;
  label?: string;
};

export default function DropdownOptionRow({
  props,
  children,
  id,
  label,
}: LookupOptionProps) {
  return (
    <div
      {...props}
      key={id}
      className={clsx(
        props?.className,
        'flex flex-row items-center w-full gap-3',
      )}
    >
      {children ?? (
      <DefaultRenderOptionRow label={label} />
      )}
    </div>
  );
}
